import React from "react";
import "./LoadingModal.css";

const LoadingModal = ({ isVisible, message = "Loading...", subtitle = "" }) => {
  if (!isVisible) return null;

  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="loading-modal-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <h3 className="loading-modal-message">{message}</h3>
        {subtitle && <p className="loading-modal-subtitle">{subtitle}</p>}
      </div>
    </div>
  );
};

export default LoadingModal;
